import script from "./RoundButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./RoundButton.vue?vue&type=script&lang=ts&setup=true"

import "./RoundButton.vue?vue&type=style&index=0&id=1f6a2ad8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f6a2ad8"]])

export default __exports__